// extracted by mini-css-extract-plugin
export default {"centerLink":"social__centerLink__OEU8J","secondaryBtns":"social__secondaryBtns__RrpHi"};